import { AnyObject, ChartOptions, StatisticsPanelConfig } from '../types';
import { ApexAxisChartSeries, ApexNonAxisChartSeries } from 'ng-apexcharts';
import { ChartType } from 'ng-apexcharts/lib/model/apex-types';

type Criteria = { [key: string]: AnyObject };

const typeMap: Record<'table' | 'line' | 'circle', ChartType | undefined> = {
  circle: 'pie',
  line: 'bar',
  table: undefined,
}

function findObjectInArray<T = AnyObject>(array: T[], criteria: Criteria): T | undefined {
  return array.find(item => {
    return Object.keys(criteria).every(key => (item as AnyObject)[key] === criteria[key]);
  });
}

function toFormat<T = AnyObject>(value: AnyObject, type: 'category' | 'datetime' | 'numeric'): T{
  if(type === 'datetime') return new Date(value) as T;
  if(type === 'numeric') return parseInt(value) as T;
  return value.toString()
}


export function dataToChatOptions(objects: AnyObject[], statConfig: StatisticsPanelConfig): Partial<ChartOptions> {
  const categoryComps: Array<{ label: string, key?: string, valueKey: string }> = [];

  statConfig.titleSeries.forEach(titleSerie => {
    if (!titleSerie.isDynamic) {
      categoryComps.push({ label: titleSerie.labelStatic || '', valueKey: titleSerie.valueKey });
    } else {
      const titles = objects
        .map(object => object[titleSerie.labelDynamicKey || ''])
        .filter(v => !!v);

      categoryComps.push(...[...new Set(titles)].sort((a, b) => toFormat(b, statConfig.titleType) - toFormat(a, statConfig.titleType)).reverse().map(label => ({
        label,
        valueKey: titleSerie.valueKey,
        key: titleSerie.labelDynamicKey
      })));
    }
  });

  const leyendKeys: Array<string> = statConfig.leyendSeries
    .map(l => l.labelDynamicKey)
    .filter(v => v !== undefined) as Array<string>;

  const seriesComp: Array<{ name: string; findObject: AnyObject }> = objects.reduce((current: Array<{
    name: string;
    findObject: AnyObject
  }>, object) => {
    const name = leyendKeys.map((key) => object[key || ''].toString(), []).join(' - ');
    const findObject = leyendKeys.reduce((current, key) => Object.assign(current, { [key || '']: object[key || ''] }), {});

    if (!current.find(s => s.name === name)) current.push({ name, findObject });

    return current;
  }, [] as Array<{ name: string; findObject: AnyObject }>);

  const series: ApexAxisChartSeries | ApexNonAxisChartSeries = seriesComp.map(serieComp => {

    const name = serieComp.name as string;

    const data = categoryComps.map(categoryComp => {
      const findObject = serieComp.findObject;
      if (categoryComp.key) findObject[categoryComp.key] = categoryComp.label;

      const object = findObjectInArray(objects, findObject);

      return parseInt((object?.[categoryComp.valueKey] as number || 0).toFixed(0));
    });

    if (statConfig.type === 'circle')
      return data[0];

    return { name, data };
  }) as ApexAxisChartSeries | ApexNonAxisChartSeries;

  const categories = categoryComps.map(c => c.label);

  const type = typeMap[statConfig.type];

  return {
    series,
    chart: {
      height: 350,
      type: type as ChartType
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      curve: 'smooth'
    },
    xaxis: {
      type: statConfig.titleType,
      categories
    }
  };
}
